import React, { Component } from 'react';
import CollapsibleContext from './CollapsibleContext';
import Content from './Content';
import Toggle from './Toggle';

class Collapsible extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };

    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  static Content = Content;
  static Toggle = Toggle;

  toggleCollapse() {
    this.setState({
      open: !this.state.open
    });
  }

  render() {
    const { children, className } = this.props;
    const { open } = this.state;
    const { toggleCollapse } = this;
    const context = { open, toggleCollapse };

    return (
      <CollapsibleContext.Provider value={context}>
        <div className={`collapsible-panel ${className}`}>{children}</div>
      </CollapsibleContext.Provider>
    );
  }
}

export default Collapsible;
